import { useQuery } from '@tanstack/react-query';
import { supaFetch } from '../lib/supabase.js';

// ─── useTokenProfile ──────────────────────────────────────────────────────────
// Resolves the retailer profile for an active catalogue token via the
// get_token_profile SECURITY DEFINER RPC.
//
// Two-stage resolution in the RPC:
//   1. Via retailer_application_id FK (Phase 7+ tokens + backfilled pre-Phase-7)
//   2. Fallback: email substring match in token label (safety net)
//
// Returns null for noprice/guest tokens with no linked application.
//
// Used to: show welcome banner, pre-fill & lock checkout fields,
// attach retailer_id to orders, enable My Orders tab.
export function useTokenProfile(token) {
  return useQuery({
    queryKey: ['tokenProfile', token ?? null],

    queryFn: async () => {
      if (!token) return null;

      const { data } = await supaFetch(
        'POST',
        'rpc/get_token_profile',
        { p_token: token },
        '',
        { 'Prefer': 'return=representation' }
      );

      // RPC returns a table — PostgREST wraps it as an array
      const profile = Array.isArray(data) ? data[0] : null;
      return profile ?? null;
    },

    enabled: !!token,
    staleTime: Infinity, // profile is immutable within a session
    retry: false,
  });
}
